import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnToggleComponent } from './dn-toggle.component';

@NgModule({
  imports: [CommonModule],
  declarations: [DnToggleComponent],
  exports: [DnToggleComponent],
})
export class DnToggleModule {}
